import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(0.5), paddingBottom: 0 },
  icon: { color: "black" },
}));

export default function PlanDiscoveryDialog({ close }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <IconButton
        className={classes.icon}
        onClick={close}
        id="plan-discovery-close"
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
}
